import { css } from "styled-components";

import { getFontFamily } from "../../../Theme/utils";

export const textInputCss = css`
  ${({
    required,
    theme: {
      colors: { grey, lighterGrey, white },
    },
  }) => `
    background-color: ${white};
    border: 2px solid ${lighterGrey};
    border-radius: 8px;
    color: ${grey};
    font-size: 14px;
    padding: 9px 17px 8px 17px;
    ::placeholder {
      color: ${grey};
      opacity: 0.8;
    }
  `}
  ${getFontFamily("regular")}
`;
